module.exports = __webpack_public_path__ + "assets/img/icon_video_active.5c7d3a45.svg";